import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { PostHogProvider } from '@posthog/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initMonitoring } from './services/monitoring';
import { initAnalytics, posthog } from './services/analytics';
import { installFlushOnHide } from './services/eventMirror';
import { captureAndScrubResetToken } from './utils/resetToken';

// Strip the password-reset token from the URL BEFORE analytics/monitoring boot,
// so the initial pageview / session replay never captures the bearer-equivalent
// secret. Must run before initAnalytics()/initMonitoring().
captureAndScrubResetToken();

// Initialise observability + analytics before the app renders.
initMonitoring();
initAnalytics();
// The activity-log mirror batches for up to 5s, so without this the last few
// events of every session — including whatever the user did immediately before
// leaving — are still in the queue when the document goes away.
installFlushOnHide();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
